const responseLogin = {
    "payload": {
      "userid": "1143244756",
      "message": "Login exitoso por ANTONIO",
      "termsConditionsAccepted": 0,
      "isPasswordChangeRequiredOnFirstLogin": true,
      "pusher_KEY": "06d012aa87d8cd1dcd7b",
      "pusher_SECRET": "a49f8c0d4eba91d635de"
    }
  };

export const service = {
  postPassword: () => new Promise(resolve => {
    setTimeout(resolve({ data: responseLogin }), 1000);
  }),
}